"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["goal", "url", "index"],

  data: function data() {
    return {
      value: this.goal.is_done,
      show: false,
      classes: "material-icons spinner",
      posting: false
    };
  },


  methods: {
    update: function update() {
      var _this = this;

      axios.put(this.url, { is_done: this.value ? 1 : 0 }).catch(function (_ref) {
        var response = _ref.response;

        Event.fire("flash", {
          message: response.data.error,
          level: "danger"
        });

        if (response.status === 404) {
          _this.$emit("healthGoalDeleted");
        }
      });
    },
    edit: function edit() {
      Fn.toggleMenu("edit-health-goal", this.goal.id);
    },
    remove: function remove() {
      var _this2 = this;

      this.show = true;
      this.posting = true;

      axios.delete("/goal/" + this.goal.id).then(function (_ref2) {
        var data = _ref2.data;

        _this2.posting = false;
        _this2.show = false;

        if (data === "ok") {
          _this2.$emit("healthGoalDeleted");
          return;
        }

        Event.fire("flash", {
          message: _this2.$t("common.messages.unknown_error"),
          level: "danger"
        });
      }).catch(function (_ref3) {
        var response = _ref3.response;

        _this2.posting = false;
        _this2.show = false;
        Event.fire("flash", {
          message: response.data.error,
          level: "danger"
        });
        _this2.$emit("healthGoalDeleted");
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/lists/HealthGoalItem.vue
// module id = KNUX
// module chunks = 0 1